import { GetInvitedTeamsMeta, GetInvitedTeamsPayload } from 'types/store/GetInvitedTeams';
import { createAsyncReducer } from 'utils/Redux';

import { getInvitedTeamsActions } from '../actions';

export default createAsyncReducer<GetInvitedTeamsMeta, GetInvitedTeamsPayload>(getInvitedTeamsActions);
